import { motion, AnimatePresence } from "framer-motion";
import { X, Share2, Download } from "lucide-react";

/**
 * Lightbox viewer for customer-document images with a WhatsApp share button
 * pinned to the top.  Receives `src` (full URL to the image) and `label`.
 */
const ImageLightbox = ({ src, label, captionExtra, onClose }) => {
  if (!src) return null;

  const shareWhatsApp = () => {
    const msg = encodeURIComponent(
      `${label || "صورة"}${captionExtra ? " — " + captionExtra : ""}\n${src}`
    );
    window.open(`https://wa.me/?text=${msg}`, "_blank", "noopener,noreferrer");
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        data-testid="image-lightbox"
        className="fixed inset-0 z-[100] bg-black/90 flex flex-col items-center justify-center p-3"
        dir="rtl"
        onClick={onClose}
      >
        {/* Top action bar */}
        <div
          className="w-full max-w-2xl flex items-center justify-between gap-2 mb-3"
          onClick={(e) => e.stopPropagation()}
        >
          <button
            onClick={shareWhatsApp}
            data-testid="lightbox-share-whatsapp"
            className="flex items-center gap-2 bg-[#25D366] hover:bg-[#1FB857] text-white font-bold px-4 py-2.5 rounded-full shadow-lg"
          >
            <Share2 className="w-4 h-4" />
            مشاركة عبر واتساب
          </button>
          <div className="flex items-center gap-2">
            <a
              href={src}
              download
              data-testid="lightbox-download"
              onClick={(e) => e.stopPropagation()}
              className="flex items-center gap-2 bg-[#3B82F6] hover:bg-[#2563eb] text-white font-bold px-3 py-2.5 rounded-full shadow-lg"
            >
              <Download className="w-4 h-4" />
            </a>
            <button
              onClick={onClose}
              data-testid="lightbox-close"
              className="bg-white/15 hover:bg-white/25 text-white p-2.5 rounded-full"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Image */}
        <motion.img
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          src={src}
          alt={label || ""}
          onClick={(e) => e.stopPropagation()}
          className="max-w-[92vw] max-h-[78vh] object-contain rounded-2xl shadow-2xl bg-black"
        />

        {/* Caption */}
        {(label || captionExtra) && (
          <div
            className="mt-3 bg-white/10 text-white text-sm px-4 py-2 rounded-full backdrop-blur-sm"
            onClick={(e) => e.stopPropagation()}
          >
            {label}
            {captionExtra ? ` — ${captionExtra}` : ""}
          </div>
        )}
      </motion.div>
    </AnimatePresence>
  );
};

export default ImageLightbox;
